




































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';

@Component({ name: 'OpportunityCompanyAddressEdit' })
export default class extends GiganautVueDialog {
  addressSearchText = '';
  entity = {
    prospectCompanyAddressType: '',
    prospectCompanyAddressBuilding: '',
    prospectCompanyAddressStreet: '',
    prospectCompanyAddressLocality: '',
    prospectCompanyAddressCity: '',
    prospectCompanyAddressRegion: '',
    prospectCompanyAddressPostcode: '',
    prospectCompanyAddressCountry: '',
    prospectCompanyAddressLatitude: null as number | null,
    prospectCompanyAddressLongitude: null as number | null,
  };

  get opportunity() { return OpportunityDetailsModule.opportunity; }
  get saving() { return OpportunityDetailsModule.saving; }

  onPlaceChanged(addressData: any, placeData: any) {
    this.entity.prospectCompanyAddressBuilding = addressData.street_number || '';
    this.entity.prospectCompanyAddressStreet = addressData.route || '';
    this.entity.prospectCompanyAddressLocality = addressData.locality || '';
    if (placeData && placeData.address_components) {
      for (const el of placeData.address_components) {
        if (el.types[0] === 'postal_town') this.entity.prospectCompanyAddressCity = el.long_name;
        if (el.types[0] === 'country') this.entity.prospectCompanyAddressCountry = el.short_name;
      }
    }
    this.entity.prospectCompanyAddressRegion = addressData.administrative_area_level_2 || '';
    this.entity.prospectCompanyAddressPostcode = addressData.postal_code || '';
    this.entity.prospectCompanyAddressLatitude = addressData.latitude ?? null;
    this.entity.prospectCompanyAddressLongitude = addressData.longitude ?? null;
  }

  @Watch('dialog')
  onDialogChanged(val: boolean) {
    if (!val || !this.opportunity) return;
    const o = this.opportunity;
    this.addressSearchText = '';
    this.entity.prospectCompanyAddressType = o.prospectCompanyAddressType;
    this.entity.prospectCompanyAddressBuilding = o.prospectCompanyAddressBuilding;
    this.entity.prospectCompanyAddressStreet = o.prospectCompanyAddressStreet;
    this.entity.prospectCompanyAddressLocality = o.prospectCompanyAddressLocality;
    this.entity.prospectCompanyAddressCity = o.prospectCompanyAddressCity;
    this.entity.prospectCompanyAddressRegion = o.prospectCompanyAddressRegion;
    this.entity.prospectCompanyAddressPostcode = o.prospectCompanyAddressPostcode;
    this.entity.prospectCompanyAddressCountry = o.prospectCompanyAddressCountry;
    this.entity.prospectCompanyAddressLatitude = o.prospectCompanyAddressLatitude;
    this.entity.prospectCompanyAddressLongitude = o.prospectCompanyAddressLongitude;
  }

  async save() {
    if (!(this.$refs.form as any).validate() || !this.opportunity) return;
    await OpportunityDetailsModule.updateProspectCompanyAddress({
      id: this.opportunity.id,
      updatedAt: this.opportunity.updatedAt,
      ...this.entity,
    });
    this.dialog = false;
  }
}
